module.exports = __webpack_public_path__ + "static/media/shopping_beach_marker.395388d0.svg";